import React from 'react';
export const NewFooter = () => {
  return <footer className="border-t border-gray-200 pt-8 pb-24 text-sm text-gray-600" data-id="element-261">
      <div className="flex items-start mb-6" data-id="element-262">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee de Bruijn" className="w-16 h-16 rounded-full object-cover mr-4 flex-shrink-0" data-id="element-263" />
        <div data-id="element-264">
          <p className="font-semibold mb-2" data-id="element-265">
            Amee de Bruijn is gediplomeerd hondengedragsconsultant niveau 5,
            opgeleid bij Calming Signs in Koningslust (2017).
          </p>
          <p className="mb-4" data-id="element-266">
            "Natuurlijk heb ik ook verdere verdiepingscursussen als mensen nog
            meer willen leren, maar tijdens het webinar probeer ik baasjes een
            stevige basis te geven."
          </p>
        </div>
      </div>

      <div className="border-t border-gray-200 pt-6" data-id="element-267">
        <p className="text-xs text-gray-500 mb-4 leading-relaxed" data-id="element-268">
          <strong data-id="element-269">Meta Advertising Disclaimer:</strong> Deze website maakt
          gebruik van Meta Pixel voor advertentiedoeleinden. Dit betekent dat
          informatie over uw bezoek aan deze website wordt gedeeld met Meta
          (Facebook) om gerichte advertenties te kunnen tonen. Door gebruik te
          maken van deze website gaat u akkoord met het gebruik van cookies en
          vergelijkbare technologieën voor analytische en advertentiedoeleinden.
          Deze pagina is een advertorial voor Stressless Dogs. Stressless Dogs
          is een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
          of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
          getoond via het Meta advertentieplatform, maar Meta is niet
          verantwoordelijk voor de inhoud of diensten aangeboden door Stressless
          Dogs.
        </p>

        <p className="text-xs text-center text-gray-500" data-id="element-270">
          © 2025 Communiceren met je hond. Alle rechten voorbehouden.
        </p>
      </div>
    </footer>;
};